import React from 'react';
import { Card, Row, Col, Tooltip, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

interface ShopStatusRowProps {
  activeTechnicians: number;
  totalTechnicians: number;
  pendingApprovals: number;
  overdueWorkOrders: number;
}

const OVERDUE_TOOLTIP =
  'Work orders past their estimated completion date that are not yet completed or cancelled (and not archived).';

const ShopStatusRow: React.FC<ShopStatusRowProps> = ({
  activeTechnicians, totalTechnicians, pendingApprovals, overdueWorkOrders,
}) => {
  const navigate = useNavigate();
  const techColor = activeTechnicians > 0 ? '#52c41a' : '#8c8c8c';
  const pendingColor = pendingApprovals > 0 ? '#faad14' : '#52c41a';
  const overdueColor = overdueWorkOrders > 0 ? '#ff4d4f' : '#52c41a';

  return (
    <Card title="Shop Status" size="small">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={8}>
          <Text type="secondary" style={{ fontSize: 12 }}>Active Technicians</Text>
          <div style={{ fontSize: 22, fontWeight: 700, color: techColor }}>
            {activeTechnicians} active / {totalTechnicians} total
          </div>
        </Col>
        <Col xs={24} sm={8}>
          <button
            type="button"
            aria-label="Pending Approvals"
            onClick={() => navigate('/owner/work-orders?status=waiting_approval')}
            style={{
              display: 'block',
              width: '100%',
              padding: 0,
              background: 'transparent',
              border: 'none',
              textAlign: 'left',
              cursor: 'pointer',
            }}
          >
            <Text type="secondary" style={{ fontSize: 12 }}>Pending Approvals</Text>
            <div style={{ fontSize: 22, fontWeight: 700, color: pendingColor }}>{pendingApprovals}</div>
          </button>
        </Col>
        <Col xs={24} sm={8}>
          <Tooltip title={OVERDUE_TOOLTIP}>
            <Text type="secondary" style={{ fontSize: 12, cursor: 'help' }}>Overdue Work Orders</Text>
          </Tooltip>
          <div style={{ fontSize: 22, fontWeight: 700, color: overdueColor }}>{overdueWorkOrders}</div>
        </Col>
      </Row>
    </Card>
  );
};

export default ShopStatusRow;
